import { render, staticRenderFns } from "./addOrEditNews.vue?vue&type=template&id=c7470c38&"
import script from "./addOrEditNews.vue?vue&type=script&lang=js&"
export * from "./addOrEditNews.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditNews.vue?vue&type=style&index=0&id=c7470c38&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports